import { createAsyncThunk } from '@reduxjs/toolkit';
import { staticResourceApi } from 'container/staticResourceApi';
import { STORE_NAME } from 'reduxStore/staticResource/initialState';
import { serializeError } from 'shared/utils/redux';

export const fetchStaticResourceList = createAsyncThunk(
  `${STORE_NAME}/fetchStaticResourceList`,
  async () => {
    return staticResourceApi.list();
  },
  { serializeError },
);
